module.exports = __webpack_public_path__ + "img/BrgyS2S.7085e311.png";